import { PATH_TO_CANCEL_FAST_STOCK_LOADING } from '../constants'
  
export function reducer(state, action) {
  if(action.type === PATH_TO_CANCEL_FAST_STOCK_LOADING) {
    return {
      ...state,
      takingCarManagement: {
        ...state.takingCarManagement,
        fastStockLoading: {
            ...state.takingCarManagement.fastStockLoading,
            pathToCancel: action.data,
        }
      }
    }
  }
  return state
}